export class CustomerPremierPartnerServiceConfigurationDTO{
    public id!: number;
    public customerId!: number;
    public premierPartnerId!: number;
    public premierServiceId!: number;
    public parameterValues!: string;
    public name!: string;
    public added!: string;
    public edited!: string;
}